// src/App.js
import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';

import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import ProductManagement from './components/ProductManagement';
import ClientManagement from './components/ClientManagement';
import ActiveOrders from './components/ActiveOrders';
import RegisterOrder from './components/RegisterOrder';
import RegisterWindowOrder from './components/RegisterWindowOrder';
import Notes from './components/Notes';
import CierreDeCaja from './components/CierreDeCaja';
import AccountsPayable from './components/AccountsPayable';
import SupplierManagement from './components/SupplierManagement';
import SupplierAccount from './components/SupplierAccount';
import ManagedInvoices from './components/ManagedInvoices';
import AnularOrdenes from './components/panel/AnularOrdenes';
import Login from './components/Login';

// Nuevas importaciones
import AccountsReceivable from './components/AccountsReceivable';
import AccountDetail from './components/AccountDetail';
import UserManagement from './components/UserManagement';
import PedidoRegister from './components/PedidoRegister';

// Historial de pedidos
import HistorialPedidos from './components/historial-pedidos';

// Cierre General
import CierreGeneral from './components/CierreGeneral';

// ✅ NUEVO: Pago de Facturas (panel nuevo)
import PayableBills from './components/PayableBills';

// ✅ NUEVO: Panel Administrativo
import PanelAdministrativo from './components/panel/PanelAdministrativo';
import AdministrarCaja from './components/panel/AdministrarCaja';
import ModificarSaldosCXC from './components/panel/ModificarSaldosCXC';
import ModificarSaldosCXP from "./components/panel/ModificarSaldosCXP";


// Ruta privada
const PrivateRoute = ({ children, token }) => {
  return token ? children : <Navigate to="/login" replace />;
};

// Sub-rutas protegidas
const AppRoutes = ({ token, handleLogin, handleLogout }) => {
  const navigate = useNavigate();

  const onLoginWrapper = (jwt) => {
    handleLogin(jwt);
    navigate('/', { replace: true });
  };

  return (
    <Routes>
      {/* Ruta pública de login */}
      <Route path="/login" element={<Login onLogin={onLoginWrapper} />} />

      {/* Rutas privadas */}
      <Route
        path="/"
        element={
          <PrivateRoute token={token}>
            <Layout onLogout={handleLogout} />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />

        {/* ✅ NUEVO: Panel administrativo */}
        <Route path="panel-administrativo" element={<PanelAdministrativo />} />
        <Route path="administrar-caja" element={<AdministrarCaja />} />




        {/* Módulos existentes */}
        <Route path="products" element={<ProductManagement />} />
        <Route path="clients" element={<ClientManagement />} />
        <Route path="orders" element={<ActiveOrders />} />
        <Route path="register-order" element={<RegisterOrder />} />
        <Route path="register-window-order" element={<RegisterWindowOrder />} />
        <Route path="notes" element={<Notes />} />
        <Route path="CierreDeCaja" element={<CierreDeCaja />} />
        <Route path="AccountsPayable" element={<AccountsPayable />} />
        <Route path="supplier-management" element={<SupplierManagement />} />
        <Route path="AccountsPayable/:id" element={<SupplierAccount />} />
        <Route path="managed-invoices" element={<ManagedInvoices />} />

        {/* ✅ NUEVO PANEL: Pago de Facturas */}
        <Route path="payable-bills" element={<PayableBills />} />

        <Route path="accounts-receivable" element={<AccountsReceivable />} />
        <Route path="accounts-receivable/:clientId" element={<AccountDetail />} />
        <Route path="user-management" element={<UserManagement />} />

        {/* Selección de tipo de pedido */}
        <Route path="pedidoregister" element={<PedidoRegister />} />

        {/* Historial de pedidos */}
        <Route path="historial-pedidos" element={<HistorialPedidos />} />

        {/* Cierre General */}
        <Route path="cierre-general" element={<CierreGeneral />} />
        <Route path="modificar-saldos-cxc" element={<ModificarSaldosCXC />} />
        <Route path="modificar-saldos-cxp" element={<ModificarSaldosCXP />} />



        {/* ✅ NUEVO: placeholder para no romper la navegación del botón "Anular Ordenes" */}
                <Route path="anular-ordenes" element={<AnularOrdenes />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to={token ? '/' : '/login'} replace />} />
    </Routes>
  );
};

function App() {
  const isJwtValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload?.exp) return true; // si no hay exp, lo tratamos como válido
    return payload.exp * 1000 > Date.now();
  } catch (e) {
    return false;
  }
};

const [token, setToken] = useState(() => {
  const saved = localStorage.getItem("token");
  if (!saved) return null;

  if (!isJwtValid(saved)) {
    localStorage.removeItem("token");
    return null;
  }
  return saved;
});


  const handleLogin = (jwt) => {
    setToken(jwt);
    localStorage.setItem('token', jwt);
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  return (
    <Router>
      <AppRoutes token={token} handleLogin={handleLogin} handleLogout={handleLogout} />
    </Router>
  );
}

export default App;
